<template id="editable-column-content">
  <div>
    <div v-if="isEditing
                  && (scope.row === editing.row)
                  && (scope.column.property === editing.column.property)">
      <input v-if="object == null" class="form-control" v-focus v-model="scope.row[property]" @blur="run"
             @keyup.enter="$emit('enter-input')">
      <input v-if="object != null" class="form-control" v-focus v-model="scope.row[object][property]" @blur="run"
             @keyup.enter="$emit('enter-input')">
    </div>
    <template  v-else>
      <span v-if="object == null" style="margin-left: 10px">{{ scope.row[property] }}</span>
      <span v-if="object != null" style="margin-left: 10px">{{ scope.row[object][property] }}</span>
    </template>
  </div>
</template>
<script>

  export default {
    name: "editableColumn",
    props: ['is-editing', 'scope', 'editing', 'on-blur', 'on-enter', 'property', 'object'],
      mounted() {
      // this.ociLog("this.property...");
      // this.ociLog(this.scope.row[this.object][this.property]);
    },
    methods:{
      run(){
        this.$emit('blur-input', {field: this.property, index: this.scope.$index, value: this.scope.row});
        // this.ociLog("run");
        // this.ociLog(this.scope.$index);
        // this.ociLog({field: this.property, index: this.scope.$index, value: this.scope.row[this.property]});
      }
    },
    directives: {
      focus: {
        // directive definition
        inserted: function (el) {
          el.focus()
        }
      }
    }
  }

</script>

<style scoped>

</style>
